import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Button} from 'antd'

import style from './hijackWarning.sass'

@inject('store') @observer
class HijackWarning extends Component {
  release = () => {
    this.props.store.user.release()
  }
  render() {
    return(
      <span styleName='wrapper'>
        User is hihacked
        <Button
          onClick={this.release}
          styleName='release'
          size='small'
        >
          Release
        </Button>
      </span>
    )
  }
}

export default HijackWarning
